import { render, staticRenderFns } from "./NewContentSlide.vue?vue&type=template&id=8d461acc&scoped=true&"
import script from "./NewContentSlide.vue?vue&type=script&lang=js&"
export * from "./NewContentSlide.vue?vue&type=script&lang=js&"
import style0 from "./NewContentSlide.vue?vue&type=style&index=0&id=8d461acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d461acc",
  null
  
)

export default component.exports